// Hold the reptile breeds needed for the patient forms
export const reptile_breeds = [
  "Agama Lizard",
  "Aldabra Giant Tortoise",
  "Alligator",
  "Anole Lizard",
  "Armadillo Lizard",
  "Asp",
  "Australian Gecko",
  "Ball Python",
  "Banana Ball Python",
  "Banded Water Snake",
  "Basilisk Lizard",
  "Bearded Dragon",
  "Black Mamba",
  "Blood Python",
  "Blue Belly Lizard",
  "Blue Iguana",
  "Boomslang",
  "Box Turtle",
  "Brookesia Micra",
  "Brown Water Snake",
  "Burmese Python",
  "Bush Viper",
  "Bushmaster Snake",
  "Caiman",
  "Caiman Lizard",
  "Carpet Python",
  "Carpet Viper",
  "Chinese Alligator",
  "Coachwhip Snake",
  "Copperhead",
  "Coral Snake",
  "Corn Snake",
  "Cottonmouth",
  "Crested Gecko",
  "Crocodile",
  "Death Adder: A Complete Guide",
  "Desert Tortoise",
  "Draco Volans Lizard",
  "Dwarf Crocodile",
  "Eastern Fence Lizard",
  "Eastern Glass Lizard",
  "Eastern Indigo Snake",
  "Eastern Rat snake",
  "Egyptian Cobra",
  "Emerald Tree Monitor",
  "Fox Snakes",
  "Freshwater Crocodile",
  "Frilled Lizard",
  "Gaboon Viper",
  "Galapagos Tortoise",
  "Garter Snake",
  "Gecko",
  "Gharial",
  "Gila Monster",
  "Glass Lizard",
  "Gopher Tortoise",
  "Grass Snake",
  "Green Anole",
  "Green Mamba",
  "Green Tree Python",
  "Hellbender",
  "Horned Lizard",
  "Horned Viper",
  "Iguana",
  "Indian Cobra",
  "Indian Star Tortoise",
  "Indigo Snake",
  "Jackson’s Chameleon",
  "King Cobra",
  "Kirtland’s snake",
  "Komodo Dragon",
  "Lazarus Lizard",
  "Leaf-Tailed Gecko",
  "Leopard Gecko",
  "Leopard Lizard",
  "Leopard Tortoise",
  "Lizard",
  "Mamba",
  "Marine Iguana",
  "Massasauga",
  "Mexican Alligator Lizard",
  "Mexican Mole Lizard",
  "Milk Snake",
  "Mojave Rattlesnake Facts",
  "Monitor Lizard",
  "Nile Crocodile",
  "Northern Alligator Lizard",
  "Northern Water Snake",
  "Painted Turtle",
  "Pied Ball Python: A Complete Guide",
  "Pine Snake",
  "Puff Adder",
  "Queen snake",
  "Radiated Tortoise",
  "Rainbow Boa",
  "Rat Snakes",
  "Rattlesnake",
  "Red Tail Boa (common boa)",
  "Red-Eared Slider",
  "Ribbon Snake: A Complete Guide",
  "River Turtle",
  "Rock Python",
  "Rough Green Snake",
  "Rubber Boa: Everything To Know",
  "Russian Tortoise",
  "Sand Lizard",
  "Sand Viper",
  "Satanic leaf-tailed gecko",
  "Scarlet Kingsnake",
  "Sea Turtle",
  "Sharp-Tailed Snake",
  "Skink Lizard",
  "Slow Worm",
  "Snake",
  "Snapping Turtle",
  "Snouted Cobra",
  "Southern Black Racer",
  "Spider Ball Python",
  "Spider-Tailed Horned Viper",
  "Spiny Hill Turtle",
  "Spitting Cobra",
  "Stiletto Snake",
  "Sulcata Tortoise",
  "Texas Indigo Snake",
  "Texas Rat Snake",
  "Texas Spiny Lizard",
  "Thorny Devil",
  "Timber Rattlesnake (Canebrake Rattlesnake)",
  "Tortoise",
  "Turtles",
  "Twig Snake",
  "Virgin Islands Dwarf Gecko",
  "Water Dragon",
  "Western Hognose Snake",
  "Western Rat Snake",
  "Whiptail Lizard",
  "Wood Turtle",
  "Yellow Spotted Lizard"
].sort()